<template>
  <tr
    v-if="dropdownIsOpened"
  >
    <td
      :colspan="columnsCount"
    >
      <div
        v-if="renderDropdown"
        class="m-table-row-dropdown-wrapper__content"
      >
        <slot
          :active="dropdownIsOpened"
          :table-row="tableRow"
        />
      </div>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'MTableRowDropdownWrapper',
    props: {
      columnsCount: {
        type: Number,
        default: 0
      },
      openedRowsKeys: {
        type: Array,
        default: Array
      },
      index: {
        type: Number,
        default: 0
      },
      tableRow: {
        type: Object,
        default: Object
      },
      uniqueKeyAttr: {
        type: String,
        default: 'id'
      }
    },
    data () {
      return {
        renderDropdown: false
      };
    },
    computed: {
      dropdownIsOpened () {
        return this.openedRowsKeys.includes(this.tableRow[this.uniqueKeyAttr]);
      }
    },
    watch: {
      dropdownIsOpened: {
        immediate: true,
        handler () {
          if (this.dropdownIsOpened && !this.renderDropdown) {
            this.renderDropdown = true;
          }
        }
      }
    }
  };
</script>

<style>
  .m-table-row-dropdown-wrapper__content {
    border-bottom: solid 1px var(--border-color);
  }
</style>
